import React, { Component } from 'react';

class PaymentMethod extends Component {

  render() {
    return (
      <div className="payment_box">
        <table className="payment_inside">
          <tbody>
            <tr>
              <td className="blank">&nbsp;</td>
              <td className="payment_text" style={{ fontSize: '12px', paddingLeft: '0px' }}>選べる支払い方法のオプション</td>
              <td className="blank">&nbsp;</td>
            </tr>
            <tr>
              <td className="blank">&nbsp;</td>
              <td className=""></td>
              <td className="blank">&nbsp;</td>
            </tr>
            <tr>
              <td className="blank">&nbsp;</td>
              <div className="row">
                <div className="">
                  <img src={require("../../assets/images/credit_card.png")} alt="Smiley face" height="70" width='110' />&nbsp;
                </div>
                <div className="">
                  <img src={require("../../assets/images/bank.jpeg")} alt="Smiley face" height="70" width="110" />
                </div>
              </div>
              <td className="blank">&nbsp;</td>
            </tr>
            <tr>
              <td className="blank">&nbsp;</td>
              <td style={{ fontSize: '12px' }}>
                クレジットカード&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 銀行振り込み
                  </td>
              <td className="blank">&nbsp;</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

}


export { PaymentMethod };